module.exports = __webpack_public_path__ + "media/28.cbbf8224.mp4";